import cn from 'classnames';
import styles from './ModalFooter.module.scss';

export const getClassNames = (className?: string) => {
  return cn(styles.footer, className);
};
